
import React, { useState } from 'react';
import { ImageUploader } from '@/components/ui/image-uploader/ImageUploader';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface ImageInsertDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onImageInserted: (imageUrl: string) => void;
}

export const ImageInsertDialog = ({
  open,
  onOpenChange,
  onImageInserted,
}: ImageInsertDialogProps) => {
  const [selectedImage, setSelectedImage] = useState<string>('');

  const handleImageUploaded = (imagePath: string) => {
    setSelectedImage(imagePath);
    onImageInserted(imagePath);
    onOpenChange(false);
    setSelectedImage('');
  };

  const handleCancel = () => {
    onOpenChange(false);
    setSelectedImage('');
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Insert Image</DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <ImageUploader
            onImageUploaded={handleImageUploaded}
            currentImage={selectedImage}
            label="Select or upload an image"
            maxWidth={1200}
            maxHeight={800}
            aspectRatio={16/9}
            maxFileSizeMB={10}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
